import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import root from "./reducers.js";

const store = createStore(root, applyMiddleware(thunk));

export default store;
export type Store = typeof store;
export type State = ReturnType<typeof store.getState>;
